import MainAdmin from '@/pages/MainAdmin.tsx'
import { AppVersionCheck } from 'common/components/AppVersionCheck.tsx'
import { AppProvider } from 'common/context/AppContext'
import UserProvider from 'common/context/UserContext'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <UserProvider agency>
      <AppProvider>
        <AppVersionCheck />
        <MainAdmin />
      </AppProvider>
    </UserProvider>
  </BrowserRouter>,
)
